import { render, staticRenderFns } from "./EditOwnerAccountInfo.vue?vue&type=template&id=1f0c5c42&scoped=true"
import script from "./EditOwnerAccountInfo.vue?vue&type=script&lang=js"
export * from "./EditOwnerAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./EditOwnerAccountInfo.vue?vue&type=style&index=0&id=1f0c5c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c5c42",
  null
  
)

export default component.exports